module.exports = __webpack_public_path__ + "img/planetary-institute.6f0ee24b.svg";